import {
  Dropdown,
  makeStyles,
  Option,
  shorthands,
  tokens,
  useId,
  Persona,
} from "@fluentui/react-components";
import React, { forwardRef, useState, useEffect } from "react";
import { DropdownIcon } from "../../../modules/default-svg";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Trash2 } from "lucide-react";

const useStyles = makeStyles({
  root: {},
  listbox: {
    maxHeight: "200px",
  },

  filledDarker: {
    // backgroundColor: tokens.colorNeutralForeground1,
    "& label": {
      display: "flex",
      fontFamily: "Figtree",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "16px",
      color: tokens.colorNeutralForeground1,
      marginBottom: "2px",
      minWidth: "290px",
      maxHeight: "32px",
    },
    "& > div": {
      display: "block", // Set dropdown container to block display
      ...shorthands.padding("5px", "0"),
    },
    "& h3": {
      color: tokens.colorNeutralForegroundInverted2,
    },
  },
});

const DropDown = (props) => {
  const {
    label,
    options,
    onChange,
    multiselect = false,
    selectedOptions = [],
    defaultVal,
    persona,
    dropDownwd,
    placeholder,
    StyleClass,
    handleBlur,
    loading = false,
    showLabel = true,
    inputRef = null,
    isInlineFocus = false,
    isRequired = false,
    errorMessage,
    onDeleteAction = null,
    disabled = false,
  } = props;

  const comboId = useId("combo-multi");
  const handleChange = (data) => {
    if (multiselect) {
      const selectedOptions = options
        .filter((option) => data.selectedOptions.includes(option.name))
        .map((option) => option.id);
      onChange(selectedOptions);
    } else {
      onChange(data.optionValue);
    }
  };

  const handleDeleteAction = (e, element) => {
      e.stopPropagation();
      if(onDeleteAction)
        onDeleteAction(element);
  }
  
  const styles = useStyles();
  return (
    <div className={`${styles.filledDarker} ${dropDownwd}`}>
      {label && showLabel && (
        <label id={`${comboId}-label`} className="CustomDropdown_label">
          {label} {isRequired && <span className="Input_staric">*</span>}
        </label>
      )}
      {loading ? (
        <Skeleton height={40} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
      ) : (
        <>
        <Dropdown
          ref={inputRef}
          multiselect={multiselect}
          placeholder={placeholder ? placeholder : `Select ${label}`}
          appearance="filled-darker"
          onOptionSelect={(event, data) => handleChange(data)}
          aria-labelledby={comboId}
          value={defaultVal}
          listbox={{ className: styles.listbox }}
          defaultValue={defaultVal}
          defaultSelectedOptions={selectedOptions}
          className={`${StyleClass} CustomDropdown_Wrapper`}
          positioning="below"
          expandIcon={<DropdownIcon />}
          onBlur={handleBlur}
          onFocus={(e) => isInlineFocus && e.target.click()}
          disabled={disabled}
        >
          {options.map((option, index) => (
            <>
              {persona ? (
                <Option key={index} text={option.name} value={option.name}>
                  <Persona
                    // avatar={{ color: "colorful", "aria-hidden": true }}
                    name={option.name}
                    image={{
                      src: option.image ? option.image : "",
                    }}
                  />
                </Option>
              ) : (
                <Option className={`dropdown-option ${option.value == "new" && 'new'}`} key={index} value={option.value} text={option.name} positioning="below">
                  <p className="dropdown-option-text">{option.name}</p>
                  {onDeleteAction && option.value != "new" &&
                    <Trash2 className="dropdown-option-action delete hidden" onClick={(e) => handleDeleteAction(e,option)} size={16} color="#d1424f"/>
                  }
                </Option>
              )}
            </>
          ))}
        </Dropdown>
        {errorMessage && (
          <p className="Input_errorMessage">{errorMessage}</p>
        )}
        </>
      )}
    </div>
  );
};

export default DropDown;
